"use strict";

var _slicedToArray = require("c:\\Users\\tdmam\\Documents\\Projects\\key-hints\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var useBoolean_1 = __importDefault(require("./array/useBoolean"));

function useBoolean(initial) {
  var _useBoolean_1$default = useBoolean_1.default(initial),
      _useBoolean_1$default2 = _slicedToArray(_useBoolean_1$default, 2),
      value = _useBoolean_1$default2[0],
      actions = _useBoolean_1$default2[1];

  return react_1.useMemo(function () {
    return Object.assign({
      value: value
    }, actions);
  }, [actions, value]);
}

exports.useBoolean = useBoolean;
exports.default = useBoolean;